import React, { Component } from "react";
import { translate } from "react-i18next";
import _debounce from "lodash/debounce";
import { provideAuth } from "shared/context/Auth";
import { provideTheme } from "shared/context/Theme";
import { Container, Divider } from "../../layout";
import Logo from "../Logo";
import navigation from "./navigation";
import search from "./search";
import { getAutocomplete } from "./search/service";
import styles from "./styles.css";
import themes from "./themes";

export class GlobalHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
      searchResults: [],
    };

    this.debouncedFetch = _debounce(this.fetchResults, 100);
  }

  fetchResults = (value) => {
    const { searchHost } = this.props;

    return getAutocomplete(value, searchHost).then((json) => {
      this.setState({
        searchResults: json.data,
      });
    });
  };

  handleSearchChange = ({ target }) => {
    const { value } = target;

    this.setState({
      searchTerm: value,
    });

    this.debouncedFetch(value);
  };

  render() {
    const { theme } = this.props;

    const {
      searchTerm,
      searchResults,
    } = this.state;

    return (
      <header
        className={theme.styles.globalHeader}
        role="banner"
      >
        <Container className={theme.styles.container}>
          <Logo className={theme.styles.logo} />

          <React.Fragment key="desktop">
            <search.Desktop
              className={theme.styles.searchDesktop}
              searchTerm={searchTerm}
              searchResults={searchResults}
              onChange={this.handleSearchChange}
            />

            <navigation.Desktop className={theme.styles.navigationDesktop} />
          </React.Fragment>

          <React.Fragment key="mobile">
            <search.Mobile
              className={theme.styles.searchMobile}
              searchTerm={searchTerm}
              searchResults={searchResults}
              onChange={this.handleSearchChange}
            />

            <navigation.Mobile
              className={theme.styles.navigationMobile}
            />
          </React.Fragment>
        </Container>

        {theme.name !== "blue" && (
          <Divider className={theme.styles.divider} container />
        )}
      </header>
    );
  }
}

export default translate()(
  provideAuth(provideTheme(GlobalHeader, styles, themes))
);
